// Yaw-aligned billboard for foliage. Each instance is a quad whose vertical
// axis is locked to world +Y and whose facing direction rotates around Y to
// point at the camera in the horizontal plane.

uniform mat4  projectionMatrix;
uniform mat4  viewMatrix;
uniform vec3  uCameraPos;
uniform float uFadeStart;
uniform float uFadeEnd;
uniform float uLogDepthBufFC;

// Quad geometry: x in [-0.5, 0.5], y in [0, 1], z = 0. Base of quad sits on
// the ground (y = 0); top of quad is one unit up before per-instance scale.
in vec3 position;
in vec2 uv;

// Per-instance state — kept tight: vec3 + vec2 = 5 floats per instance.
in vec3 iPosition;    // world position of the quad's base
in vec2 iScaleSeed;   // x = world-space height (also width), y = seed in [0,1]

out vec2  vUv;
out float vFade;
out float vSeed;
out float vFragDepth;

void main() {
  // Yaw to face the camera horizontally. atan(x, z) = 0 when facing +Z.
  vec3 toCam = uCameraPos - iPosition;
  float yaw = atan(toCam.x, toCam.z);
  float c = cos(yaw);
  float s = sin(yaw);

  float scale = iScaleSeed.x;
  // Dead slots: scale = 0 collapses the quad to a point (no fragments).
  vec3 local = position * scale;

  // Rotate around Y. local.z is 0 for our quad, but kept for generality.
  vec3 rotated = vec3(
    local.x * c + local.z * s,
    local.y,
    -local.x * s + local.z * c
  );

  vec3 worldPos = iPosition + rotated;
  gl_Position = projectionMatrix * viewMatrix * vec4(worldPos, 1.0);

  // Logarithmic depth buffer — RawShaderMaterial doesn't get this for free.
  gl_Position.z = log2(max(1e-6, gl_Position.w + 1.0)) * uLogDepthBufFC - 1.0;
  gl_Position.z *= gl_Position.w;
  vFragDepth = 1.0 + gl_Position.w;

  // Distance fade — 3D distance so high-altitude views also fade.
  float dist = distance(worldPos, uCameraPos);
  vFade = 1.0 - smoothstep(uFadeStart, uFadeEnd, dist);

  vUv = uv;
  vSeed = iScaleSeed.y;
}
